import {
  Box,
  Grid,
  Paper,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useQuery } from "react-query";
import Radio from "@mui/material/Radio";
import { useForm } from "react-hook-form";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import { toast } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import * as Styles from "../../components/common/Styled/Styles.js";
import BreadCrumbHeader from "../../components/Header/BreadCrumbHeader";

// Get All Roles
const useGetAllRoles = () =>
  useQuery("all-roles", async () => {
    return (await axios.get("/api/v1/roles/all-roles")).data;
  });

export const AddMember = () => {
  let navigate = useNavigate();
  const [passField, setPassField] = useState(true);
  const [rightsarray, setRightsarray] = useState([]);
  const [tokenlimit, setTokenLimit] = useState("custom");
  const [showPassword, setShowPassword] = useState(false);
  const [confrimPassField, setConfrimPassField] = useState(true);
  const [productRights, setProductRights] = useState("VIEW_ONLY");
  const [roleAndPermission, setRoleAndPermission] = useState("VIEW_EXISTING");
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedAccess, setSelectedAccess] = useState({
    BUYER: [],
    SELLER: [],
  });
  const [isCustomEnabled, setIsCustomEnabled] = useState(false);
  const [selectedroleAndPermission, setSelectedroleAndPermission] = useState(
    []
  );

  const handleroleCheckboxChange = (value) => {
    setSelectedroleAndPermission((prev) => {
      const updatedValues = prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value];

      if (
        (value === "VIEW_EXISTING" || value === "VIEW_EDIT_EXISTING") &&
        !updatedValues.includes("VIEW_EXISTING") &&
        !updatedValues.includes("VIEW_EDIT_EXISTING")
      ) {
        return updatedValues.filter(
          (item) => item !== "DELETE_EXISTING_USER" && item !== "ADD_NEW_USER"
        );
      }

      return updatedValues;
    });
  };

  const isViewSelected =
    selectedroleAndPermission.includes("VIEW_EXISTING") ||
    selectedroleAndPermission.includes("VIEW_EDIT_EXISTING");

  const handleShowPasswordClick = () => {
    setShowPassword(!showPassword);
  };
  const handleShowPasswordClickConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };

  const ProductRightsChange = (event) => {
    setProductRights(event.target.value);
  };

  const RoleAndPermissionChange = (event) => {
    setRoleAndPermission(event.target.value);
  };
  const TokenLimitChange = (event) => {
    if (event.target.value === "custom") {
      setTokenLimit("custom");
    } else {
      setTokenLimit(event.target.value);
    }
  };

  async function handleRightsArray(rights) {
    if (rightsarray.includes(rights)) {
      const filteredArray = rightsarray.filter((item) => item !== rights);
      setRightsarray(filteredArray);
      return;
    }
    setRightsarray([...rightsarray, rights]);
  }

  // useForm
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();

  // For PAssword Strong
  const isStrongPassword = (password) => {
    const minLength = 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);

    return (
      password.length >= minLength && hasUppercase && hasLowercase && hasNumber
    );
  };

  // check Phone Number
  const isValidPhoneNumber = (value) => {
    return /^\d{10}$/.test(value);
  };

  const isValidEmailNumber = (value) => {
    if (!value || typeof value !== "string") return false; // Check if value exists and is a string

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Ensure it follows the email format
    if (!emailPattern.test(value)) return false;

    // Check for multiple '@' occurrences
    if (value.split("@").length !== 2) return false;

    // Check if domain contains at least one '.'
    const domainPart = value.split("@")[1];
    if (!domainPart.includes(".")) return false;

    // Check for consecutive dots
    if (value.includes("..")) return false;

    // Ensure email doesn't start or end with special characters
    const specialChars = /[^a-zA-Z0-9@._-]/;
    if (specialChars.test(value.charAt(0)) || specialChars.test(value.charAt(value.length - 1))) return false;

    return true;
  };


  // Get Roles
  const { data: roledata } = useGetAllRoles();

  const addUserFormSubmitHandler = handleSubmit(async (formData) => {
    if (formData.roleId === "") {
      toast.error("Please Select Role", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    } else if (tokenlimit !== "noaccess" && !formData.tokenlimit) {
      toast.error("Please Add CustomToken Limit", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    } else if (
      selectedAccess?.BUYER?.length <= 0 &&
      selectedAccess?.SELLER?.length <= 0
    ) {
      toast.error("Please Select Role & Rights of the User", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    } else if (selectedroleAndPermission?.length <= 0) {
      toast.error("Please Select Role & Rights of other User", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    } else {
      await axios
        .post(
          "assign/add_iamUser",
          {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            roleId: formData.roleId.toString(),
            password: formData.password,
            confirmpassword: formData.confirmpassword,
            tokens: tokenlimit === "noaccess" ? 0 : Number(formData.tokenlimit),
            tokenlimit:
              tokenlimit === "noaccess" ? 0 : Number(formData.tokenlimit),
            productRights: productRights,
            rightsarray: selectedAccess,
            roleAndPermission: selectedroleAndPermission,
          },
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res?.data?.status === 400) {
            toast.error(res?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else if (res?.data?.status === 200) {
            toast.success("Member Added Successfully", {
              position: "top-center",
              autoClose: 3000,
            });
            setTimeout(() => {
              navigate("/home/company_members");
            }, 2000);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
        });
    }
  });

  const handleRoleChange = (e) => {
    const selectedRoleId = e.target.value;

    if (!selectedRoleId) {
      // Reset access when "Please Select" is chosen
      setSelectedAccess({ BUYER: [], SELLER: [] });
      return;
    }

    const selectedRoleObj = roledata?.roles?.find(
      (role) => role._id === selectedRoleId
    );

    if (selectedRoleObj) {
      const roleName = selectedRoleObj.RoleName;

      // Separate access rights for Buyer and Seller
      const buyerAccess = Buyerhubarray.filter((item) =>
        item.roles.includes(roleName)
      ).map((item) => item.access);

      const sellerAccess = Sellerhubarray.filter((item) =>
        item.roles.includes(roleName)
      ).map((item) => item.access);

      setSelectedAccess({ BUYER: buyerAccess, SELLER: sellerAccess });
    }
  };


  const handleCheckboxChange = (value, type) => {
    setSelectedAccess((prevAccess) => {
      const updatedAccess = prevAccess[type].includes(value)
        ? prevAccess[type].filter((access) => access !== value)
        : [...prevAccess[type], value];

      return { ...prevAccess, [type]: updatedAccess };
    });
  };

  const Buyerhubarray = [
    {
      roles: ["ADMIN", "FINANCE", "LEGAL", "MANAGER", "DASHBOARD VIEWER"],
      access: "WALLET_DASHBOARD",
      name: "Wallet Dashboard",
    },
    {
      roles: ["ADMIN", "FINANCE", "LEGAL", "DASHBOARD VIEWER"],
      access: "CREDIT_LINE_VIEW",
      name: "Trade Limit  (View)",
    },
    {
      roles: ["ADMIN", "FINANCE"],
      access: "CREDIT_LINE_APPLY",
      name: "Trade Limit  (Apply)",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "MY_ORDERS",
      name: "My Orders",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "TRADE_MANAGEMENT",
      name: "Trade Management",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "R AND D",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "WISHLIST_AND_WANTLIST",
      name: "Wishlist and Wantlist",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "R AND D",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "TRACK_YOUR_PURCHASES",
      name: "Track your Purchases",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
        "DASHBOARD VIEWER",
      ],
      access: "LOGOUT",
      name: "Logout",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
        "DASHBOARD VIEWER",
      ],
      access: "NOTIFICATIONS",
      name: "Notifications",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "CART",
      name: "Cart",
    },
    {
      roles: [
        "ADMIN",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
        "DASHBOARD VIEWER",
      ],
      access: "MESSAGES",
      name: "Messages",
    },
    // {
    //   roles: [
    //     "ADMIN",
    //     "OPERATIONS",
    //     "PLANNING AND PROCUREMENT",
    //     "FINANCE",
    //     "R AND D",
    //     "LEGAL",
    //     "MANAGER",
    //     "EXECUTIVE",
    //     "DASHBOARD VIEWER",
    //   ],
    //   access: "PROFILE_VIEW",
    //   name: "Profile (View)",
    // },
    // {
    //   roles: ["ADMIN", "LEGAL"],
    //   access: "PROFILE_VIEW_AND_EDIT",
    //   name: "Profile (View and Edit)",
    // },
  ];

  const Sellerhubarray = [
    {
      roles: ["ADMIN", "FINANCE", "LEGAL", "MANAGER", "DASHBOARD VIEWER"],
      access: "WALLET_DASHBOARD",
      name: "Wallet Dashboard",
    },
    {
      roles: ["ADMIN", "FINANCE", "LEGAL", "DASHBOARD VIEWER"],
      access: "CREDIT_LINE_VIEW",
      name: "Trade Limit  (View)",
    },
    {
      roles: ["ADMIN", "FINANCE"],
      access: "CREDIT_LINE_APPLY",
      name: "Trade Limit  (Apply)",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "ORDERS",
      name: "Orders",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "TRADE_MANAGEMENT",
      name: "Trade Management",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "R AND D",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "PRODUCTS_UPLOAD",
      name: "Products Upload",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "R AND D",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "UPDATE_YOUR_SALES",
      name: "Update your sales",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "PLANNING AND PROCUREMENT",
        "FINANCE",
        "R AND D",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "PRODUCT_ANALYSIS",
      name: "Product Analysis",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "OPERATIONS",
        "FINANCE",
        "R AND D",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "BXI_PAYOUTS",
      name: "BXI Payouts",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
        "DASHBOARD VIEWER",
      ],
      access: "LOGOUT",
      name: "Logout",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
        "DASHBOARD VIEWER",
      ],
      access: "NOTIFICATIONS",
      name: "Notifications",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
      ],
      access: "CART",
      name: "Cart",
    },
    {
      roles: [
        "ADMIN",
        "BUSINESS DEVELOPMENT",
        "MARKETING",
        "OPERATIONS",
        "FINANCE",
        "R AND D",
        "LEGAL",
        "MANAGER",
        "EXECUTIVE",
        "DASHBOARD VIEWER",
      ],
      access: "MESSAGES",
      name: "Messages",
    },
    // {
    //   roles: [
    //     "ADMIN",
    //     "BUSINESS DEVELOPMENT",
    //     "MARKETING",
    //     "OPERATIONS",
    //     "FINANCE",
    //     "R AND D",
    //     "LEGAL",
    //     "MANAGER",
    //     "EXECUTIVE",
    //     "DASHBOARD VIEWER",
    //   ],
    //   access: "PROFILE_VIEW",
    //   name: "Profile (View)",
    // },
    // {
    //   roles: ["ADMIN", "LEGAL"],
    //   access: "PROFILE_VIEW_AND_EDIT",
    //   name: "Profile (View and Edit)",
    // },
  ];

  return (
    <Paper
      sx={{
        width: "100%",
        height: "100%",
        bgcolor: "transparent",
        boxShadow: "none",
      }}
      elevation={0}
    >
      <BreadCrumbHeader MainText={"Add User Details"} showbreadcrumb={true} />
      <form onSubmit={addUserFormSubmitHandler}>
        <Paper
          sx={{
            width: "100%",
            mx: "auto",
            height: "100%",
            borderRadius: "17px",
          }}
          elevation={0}
        >
          <Grid container>
            <Box sx={Styles.AdjAddmember}>
              <Grid item xl={12} lg={12} sd={12} xs={12} md={12}>
                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    mt: 2,
                  }}
                >
                  <Typography
                    sx={{
                      ...Styles.TitletextStyle,
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#6B80B7",
                    }}
                  >
                    Name/Email/ Phone No. of User
                  </Typography>
                  <Typography
                    sx={{
                      ...Styles.TitleDescriptionStyle,
                      color: "#6B80B7",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Provide the user's name, email, and phone number to build
                    login information.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 3,
                  }}
                >
                  <Box sx={adjInput}>
                    <Typography
                      sx={{ ...Styles.TitletextStyle, color: "#6B80B7" }}
                    >
                      User Name{" "}
                    </Typography>
                    <input
                      style={Styles.InputStyle}
                      fullWidth
                      placeholder="Shubham"
                      {...register("name", {
                        required: "Name is required",
                      })}
                      onKeyDown={(e) => {
                        if (e.key === " " && e.target.selectionStart === 0) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.name && (
                      <p style={{ color: "red" }}>{errors.name.message}</p>
                    )}
                  </Box>
                  <Box sx={adjInput}>
                    <Typography
                      sx={{ ...Styles.TitletextStyle, color: "#6B80B7" }}
                    >
                      User Email (Login Username){" "}
                    </Typography>
                    <input
                      style={Styles.InputStyle}
                      fullWidth
                      placeholder="procurement@bxi.com"
                      {...register("email", {
                        required: "Email is required",
                        validate: (value) =>
                          isValidEmailNumber(value) ||
                          "Please enter a valid Email",
                      })}
                      onKeyDown={(e) => {
                        if (e.key === " " && e.target.selectionStart === 0) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.email && (
                      <p style={{ color: "red" }}>{errors.email.message}</p>
                    )}
                  </Box>
                  <Box sx={adjInput}>
                    <Typography
                      sx={{ ...Styles.TitletextStyle, color: "#6B80B7" }}
                    >
                      User Phone no.{" "}
                    </Typography>
                    <input
                      style={Styles.InputStyle}
                      fullWidth
                      placeholder="Phone no."
                      {...register("phone", {
                        required: "Phone is required",

                        validate: (value) =>
                          isValidPhoneNumber(value) ||
                          "Please enter a valid Phone number",
                      })}
                      onKeyDown={(e) => {
                        if (e.key === " " && e.target.selectionStart === 0) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.phone && (
                      <p style={{ color: "red" }}>{errors.phone.message}</p>
                    )}
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Grid>

          <Grid container>
            <Box sx={{ ...Styles.AdjAddmember, mt: 2 }}>
              <Grid item xl={12} lg={12} sd={12} xs={12} md={12}>
                <Typography
                  sx={{
                    ...Styles.TitletextStyle,
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#6B80B7",
                  }}
                >
                  Role & Rights of the User
                </Typography>

                <Typography
                  sx={{ ...Styles.TitleDescriptionStyle, color: "#6B80B7" }}
                >
                  Role of the User
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "45%",
                    height: "auto",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <select
                    style={{
                      ...Styles.InputStyle,
                      width: "50%",
                      borderRadius: "10px",
                      minWidth: "366px",
                    }}
                    fullWidth
                    placeholder="Select"
                    {...register("roleId")}
                    onChange={handleRoleChange}
                  >
                    <option defaultChecked value={""}>
                      Please Select
                    </option>
                    {roledata?.roles?.map((role) => (
                      <option key={role._id} value={role._id}>
                        {role.RoleName}
                      </option>
                    ))}
                  </select>
                  <Button
                    sx={{
                      ...Styles.AddMemberBtn,
                      background: isCustomEnabled ? "#fff" : "#445FD2",
                      color: isCustomEnabled ? "#445FD2" : "#fff",
                      border: isCustomEnabled
                        ? "1px solid #445FD2"
                        : "1px solid transparent",
                      "&:hover": {
                        background: !isCustomEnabled ? "#fff" : "#445FD2",
                        border: !isCustomEnabled
                          ? "1px solid #445FD2"
                          : "1px solid transparent",
                        color: !isCustomEnabled ? "#445FD2" : "#fff",
                      },
                    }}
                    onClick={() => setIsCustomEnabled(!isCustomEnabled)}
                  >
                    Custom
                  </Button>
                </Box>
                <Grid container sx={{ width: "50%", mt: 2 }}>
                  <Grid item xl={6} lg={6} md={6} xs={6}>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{
                          ...Styles.CheckboxtextStyle,
                          color: "#6B80B7",
                        }}
                      >
                        Buyer Hub Access
                      </Typography>
                      <Box sx={{ mt: 2 }}>
                        {Buyerhubarray.map((item, index) => (
                          <Box sx={Styles.AdjCheckBox} key={index}>
                            <input
                              type="checkbox"
                              {...register("productRights")}
                              style={{
                                marginBottom: "10px",
                                width: "20px",
                                height: "20px",
                                border: `1px solid ${isCustomEnabled ? "#FF9800" : "#445FD2"}`,
                                borderRadius: "4px",
                                cursor: isCustomEnabled ? "pointer" : "not-allowed",
                                position: "relative",
                                backgroundColor: selectedAccess.BUYER.includes(item.access)
                                  ? "#445FD2"
                                  : "transparent",
                              }}
                              value={item.access}
                              checked={selectedAccess.BUYER.includes(item.access)}
                              disabled={!isCustomEnabled}
                              onChange={() => handleCheckboxChange(item.access, "BUYER")}
                            />
                            <Typography
                              sx={{
                                ...Styles.CheckboxtextStyle,
                                color: selectedAccess.BUYER.includes(item.access) ? "#6B80B7" : "#6B80B7",
                                fontWeight: selectedAccess.BUYER.includes(item.access) ? "bold" : "normal",
                              }}
                            >
                              {item.name}
                            </Typography>
                          </Box>
                        ))}

                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} xs={6}>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{ ...Styles.CheckboxtextStyle, color: "#6B80B7" }}
                      >
                        Seller Hub Access
                      </Typography>
                      <Box sx={{ mt: 2 }}>
                        {Sellerhubarray.map((item, index) => (
                          <Box sx={Styles.AdjCheckBox} key={index}>
                            <input
                              type="checkbox"
                              {...register("productRights")}
                              style={{
                                marginBottom: "10px",
                                width: "20px", // Adjust size for better visibility
                                height: "20px",
                                border: `1px solid ${isCustomEnabled ? "#FF9800" : "#445FD2"}`,
                                borderRadius: "4px",
                                cursor: isCustomEnabled ? "pointer" : "not-allowed",
                                position: "relative",
                                backgroundColor: selectedAccess.SELLER.includes(item.access)
                                  ? "#445FD2" // Green when checked
                                  : "transparent",
                              }}
                              value={item.access}
                              checked={selectedAccess.SELLER.includes(
                                item.access
                              )}
                              disabled={!isCustomEnabled}
                              onChange={() =>
                                handleCheckboxChange(item.access, "SELLER")
                              }
                            />
                            <Typography
                              sx={{
                                ...Styles.CheckboxtextStyle,
                                color: selectedAccess.SELLER.includes(item.access) ? "#6B80B7" : "#6B80B7",
                                fontWeight: selectedAccess.SELLER.includes(item.access) ? "bold" : "normal",
                              }}
                            >
                              {item.name}
                            </Typography>
                            {/* <Typography
                              sx={{
                                ...Styles.CheckboxtextStyle,
                                color: "#6B80B7",
                              }}
                            >
                              {item.name}
                            </Typography> */}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Box sx={{ ...Styles.AdjAddmember, mt: 5 }}>
            <Box sx={BarterCoin}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                onChange={ProductRightsChange}
                value={productRights}
              >
                <Typography
                  sx={{
                    ...Styles.TitletextStyle,
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#6B80B7",
                  }}
                >
                  Edit Rights of User (Rights to View and Edit Profile Page)
                </Typography>
                <FormControlLabel
                  value="VIEW_ONLY"
                  onChange={ProductRightsChange}
                  control={<Radio sx={RadioDes} />}
                  label={<StyledLabel>View Only</StyledLabel>}
                />
                <FormControlLabel
                  value="VIEW_AND_EDIT"
                  sx={{
                    ml: 5,
                  }}
                  control={<Radio sx={RadioDes} />}
                  label={<StyledLabel>View & Edit</StyledLabel>}
                />
                <FormControlLabel
                  value="NO_ACCESS"
                  sx={{
                    ml: 5,
                  }}
                  control={<Radio sx={RadioDes} />}
                  label={<StyledLabel>No Access</StyledLabel>}
                />
              </RadioGroup>
            </Box>
          </Box>

          <Box sx={{ ...Styles.AdjAddmember, mt: 5 }}>
            <Box sx={BarterCoin}>
              <Box>
                <Typography
                  sx={{
                    ...Styles.TitletextStyle,
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#6B80B7",
                  }}
                >
                  Trade Credits Access
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                  }}
                >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={tokenlimit}
                    onChange={TokenLimitChange}
                  >
                    <FormControlLabel
                      value="select"
                      control={<Radio sx={RadioDes} />}
                      label={
                        <StyledLabel>Select Trade Credits Limit</StyledLabel>
                      }
                    />

                    <FormControlLabel
                      value="custom"
                      control={<Radio sx={RadioDes} />}
                      label={
                        <StyledLabel>Custom Trade Credits Limit</StyledLabel>
                      }
                    />

                    <FormControlLabel
                      value="noaccess"
                      control={<Radio sx={RadioDes} />}
                      label={<StyledLabel>No Access</StyledLabel>}
                    />
                  </RadioGroup>
                  {tokenlimit === "select" ? (
                    <select
                      style={{
                        ...Styles.InputStyle,
                        width: "30%",
                        color: "#445FD2",
                        borderRedius: "10px",
                      }}
                      fullWidth
                      placeholder="Select"
                      {...register("tokenlimit")}
                      disabled={tokenlimit === "custom"}
                    >
                      <option value="50000">
                        Burn Upton 50000 Trade Credits
                      </option>
                      <option value="100000">
                        Burn Upton 100000 Trade Credits{" "}
                      </option>
                      <option value="250000">
                        Burn Upton 250000 Trade Credits
                      </option>
                      <option value="500000">
                        Burn Upton 500000 Trade Credits
                      </option>
                    </select>
                  ) : tokenlimit === "custom" ? (
                    <input
                      type="number"
                      style={Styles.InputStyle}
                      fullWidth
                      placeholder="Amount of Trade Credits"
                      {...register("tokenlimit", {
                        required: "customTokenLimit is required",
                        validate: (value) =>
                          parseInt(value) < 500001 ||
                          "Value must be less than 500000",
                      })}
                      onKeyDown={(e) => {
                        if (e.key === " " && e.target.selectionStart === 0) {
                          e.preventDefault();
                        }
                      }}
                      disabled={tokenlimit !== "custom"}
                    />
                  ) : null}
                  {errors.tokenlimit && (
                    <p style={{ color: "red" }}>{errors.tokenlimit.message}</p>
                  )}
                  {errors.customTokenLimit && (
                    <p style={{ color: "red" }}>
                      {errors.customTokenLimit.message}
                    </p>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>

          <Box sx={{ ...Styles.AdjAddmember, mt: 5 }}>
            <Box sx={BarterCoin}>
              <Typography
                sx={{
                  ...Styles.TitletextStyle,
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#6B80B7",
                }}
              >
                Can user edit roles, rights and permissions of other users?
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  py: 1,
                }}
              >
                <Box sx={Styles.AdjCheckBox}>
                  <input
                    type="checkbox"
                    onChange={() => handleroleCheckboxChange("VIEW_EXISTING")}
                    checked={selectedroleAndPermission.includes(
                      "VIEW_EXISTING"
                    )}
                    style={{ marginBottom: "10px" }}
                    value="VIEW_EXISTING"
                  />
                  <StyledLabel>View Existing</StyledLabel>
                </Box>
                <Box sx={{ ...Styles.AdjCheckBox, ml: 5 }}>
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleroleCheckboxChange("VIEW_EDIT_EXISTING")
                    }
                    checked={selectedroleAndPermission.includes(
                      "VIEW_EDIT_EXISTING"
                    )}
                    style={{ marginBottom: "10px" }}
                    value="VIEW_EDIT_EXISTING"
                  />
                  <StyledLabel>View and Edit Existing User</StyledLabel>
                </Box>
                <Box sx={{ ...Styles.AdjCheckBox, ml: 5 }}>
                  <input
                    type="checkbox"
                    onChange={() => handleroleCheckboxChange("ADD_NEW_USER")}
                    checked={selectedroleAndPermission.includes("ADD_NEW_USER")}
                    style={{ marginBottom: "10px" }}
                    value="ADD_NEW_USER"
                    disabled={!isViewSelected}
                  />
                  <StyledLabel>Add New User</StyledLabel>
                </Box>
                <Box sx={{ ...Styles.AdjCheckBox, ml: 5 }}>
                  <input
                    type="checkbox"
                    onChange={() =>
                      handleroleCheckboxChange("DELETE_EXISTING_USER")
                    }
                    checked={selectedroleAndPermission.includes(
                      "DELETE_EXISTING_USER"
                    )}
                    style={{ marginBottom: "10px" }}
                    value="DELETE_EXISTING_USER"
                    disabled={!isViewSelected}
                  />
                  <StyledLabel>Delete Existing User</StyledLabel>
                </Box>
              </Box>
            </Box>
          </Box>

          <Grid container>
            <Box sx={{ ...Styles.AdjAddmember, mt: 3 }}>
              <Box sx={BarterCoin}>
                <Typography
                  sx={{
                    ...Styles.TitletextStyle,
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#6B80B7",
                  }}
                >
                  Password Details
                </Typography>

                <Grid item xl={12} lg={12} sd={12} xs={12} md={12}>
                  <Box
                    sx={{
                      display: "grid",
                      minWidth: "425px",
                      height: "100px",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        height: "auto",
                        justifyContent: "space-between",
                        alignItems: "center",
                        bgcolor: "transparent",
                        mt: "10px",
                      }}
                    >
                      <Box sx={adjInput}>
                        <StyledLabel>Enter Password</StyledLabel>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <input
                            style={Styles.InputStyle}
                            fullWidth
                            type={passField ? "password" : "text"}
                            placeholder="Enter Password"
                            {...register("password", {
                              required: true,
                              validate: isStrongPassword,
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === " " &&
                                e.target.selectionStart === 0
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />{" "}
                          <Typography
                            sx={{
                              fontSize: "12px",
                              cursor: "pointer",
                              mt: "0px",
                              cursor: "pointer",
                              position: "absolute",
                              right: "2%",
                            }}
                            onClick={() => {
                              setPassField(!passField);
                            }}
                          >
                            <IconButton onClick={handleShowPasswordClick}>
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </Typography>
                        </Box>
                        {errors.password && (
                          <p
                            style={{
                              color: "red",
                            }}
                          >
                            Password should be at least 8 characters long and
                            contain uppercase letters, lowercase letters, and
                            numbers.
                          </p>
                        )}
                      </Box>
                      <Box
                        sx={{
                          ...adjInput,
                          ml: 10,
                        }}
                      >
                        <StyledLabel>Confirm Password</StyledLabel>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <input
                            style={Styles.InputStyle}
                            fullWidth
                            type={confrimPassField ? "password" : "text"}
                            placeholder="Confirm Password"
                            {...register("confirmPassword", {
                              required: "Confirm Password is required",
                              validate: (value) =>
                                value === watch("password") ||
                                "Passwords do not match",
                            })}
                            onKeyDown={(e) => {
                              if (
                                e.key === " " &&
                                e.target.selectionStart === 0
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "12px",
                              mt: "0px",
                              cursor: "pointer",
                              position: "absolute",
                              right: "2%",
                            }}
                            onClick={() => {
                              setConfrimPassField(!confrimPassField);
                            }}
                          >
                            <IconButton
                              onClick={handleShowPasswordClickConfirm}
                            >
                              {showPasswordConfirm ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </Typography>
                        </Box>
                        {errors.confirmPassword && (
                          <p
                            style={{
                              color: "red",
                            }}
                          >
                            {errors.confirmPassword.message}
                          </p>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Box sx={Styles.AddmemberBorder}>
            <Box
              sx={{
                height: "100%",
                width: "100%",
                maxWidth: "450px",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                gap: "1rem",
                alignContent: "center",
              }}
            >
              <Button
                sx={Styles.AddMemberBtn}
                onClick={() => {
                  navigate("/home/company_members");
                }}
              >
                Cancel
              </Button>
              <Button
                sx={{
                  ...Styles.AddMemberBtn,
                  background: "#445FD2",
                  color: "#fff",
                  "&:hover": {
                    border: "1px solid #445FD2",
                    color: "#445FD2",
                  },
                }}
                type="submit"
              >
                Add User
              </Button>
              <Button
                sx={Styles.AddMemberBtn}
                onClick={() => {
                  reset({
                    password: "",
                    name: "",
                    email: "",
                    phone: "",
                    roleId: "",
                    productRights: false,
                    purchaseRights: false,
                    salesRights: false,
                    financeRights: false,

                    tokenlimit: "",
                    confirmPassword: "",
                  });
                  setRightsarray([]);
                  setProductRights(null);
                  setRoleAndPermission(null);
                  setTokenLimit(null);
                }}
              >
                Reset
              </Button>
            </Box>
          </Box>
        </Paper>
      </form>
    </Paper>
  );
};

const StyledLabel = styled("span")({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#6B80B7",
});

const adjInput = {
  height: "90px",
  display: "grid",
};

const BarterCoin = {
  width: "100%",
  maxWidth: "1500px",
  height: "auto",
};

const RadioDes = {
  color: "#445FD2",
  "& .MuiSvgIcon-root": {
    fontSize: 22,
  },
};
